import InternalColors from '@polestar/component-warehouse-react/tokens/internal-colors/InternalColors';
import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const InternalStatusBadgeTheme = {
    internalStatusBadge: {
        light: {
            variants: {
                active: {
                    borderColor: InternalColors.systemGreen,
                    iconColor: InternalColors.systemGreen,
                    textColor: withOpacity(Colors.black, Opacities.medium),
                },
                attention: {
                    borderColor: Colors.error,
                    iconColor: Colors.error,
                    textColor: withOpacity(Colors.black, Opacities.medium),
                },
                default: {
                    borderColor: withOpacity(Colors.black, Opacities.medium),
                    iconColor: withOpacity(Colors.black, Opacities.medium),
                    textColor: withOpacity(Colors.black, Opacities.medium),
                },
                inactive: {
                    borderColor: withOpacity(Colors.black, Opacities.low),
                    iconColor: withOpacity(Colors.black, Opacities.medium),
                    textColor: withOpacity(Colors.black, Opacities.medium),
                },
                pending: {
                    borderColor: Colors.accessibleSafetyOrange,
                    iconColor: Colors.accessibleSafetyOrange,
                    textColor: withOpacity(Colors.black, Opacities.medium),
                },
            },
        },
        dark: {
            variants: {
                active: {
                    borderColor: InternalColors.systemGreen,
                    iconColor: InternalColors.systemGreen,
                    textColor: withOpacity(Colors.white, Opacities.medium),
                },
                attention: {
                    borderColor: Colors.error,
                    iconColor: Colors.error,
                    textColor: withOpacity(Colors.white, Opacities.medium),
                },
                default: {
                    borderColor: withOpacity(Colors.white, Opacities.medium),
                    iconColor: withOpacity(Colors.white, Opacities.medium),
                    textColor: withOpacity(Colors.white, Opacities.medium),
                },
                inactive: {
                    borderColor: withOpacity(Colors.white, Opacities.low),
                    iconColor: withOpacity(Colors.white, Opacities.medium),
                    textColor: withOpacity(Colors.white, Opacities.medium),
                },
                pending: {
                    borderColor: Colors.accessibleSafetyOrange,
                    iconColor: Colors.accessibleSafetyOrange,
                    textColor: withOpacity(Colors.white, Opacities.medium),
                },
            },
        },
    },
};
export default InternalStatusBadgeTheme;
